var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-xl":""}},[_c('h2',{staticClass:"display-1"},[_vm._v("Neues Prüfungsset")]),_vm._v(" "),_c('v-flex',[_c('EditSetComponent',{attrs:{"set":_vm.set,"verfahren":_vm.verfahren,"arten":_vm.arten,"sektoren":_vm.sektoren},on:{"onSave":_vm.saveSet}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }